<template>
    <v-app>
                <v-card class="elevation-0">
                    <v-tabs
                    v-model="tab"
                    background-color="transparent"
                    color="green"
                    class="ml-lg-0 ml-n13"
                    style="width:110% !important"
                    >
                    <v-tab
                        v-for="item in items"
                        :key="item"
                    >
                    <span class="tab-color"> {{ item }} </span>
                    </v-tab>
                    </v-tabs>

                    <v-tabs-items v-model="tab">
                    <v-tab-item
                        v-for="item in items"
                        :key="item"
                    >
                        <v-card
                        color=""
                        flat class="px-lg-10 py-lg-5"
                        v-if="item == 'LEVEL TEST'"
                        >
                        

                        
                        <LevelTest/>


                        </v-card>

                        <v-card
                        color=""
                        flat class="px-lg-10 py-lg-5"
                        v-if="item == 'REGULAR CLASS'"
                        >

                        <RegularClass />



                        </v-card>
                        <v-card
                        color="rgb(251, 251, 251)"
                        flat class="px-lg-10 py-lg-5"
                        v-if="item == 'SUMMARY'"
                        >
                            <Summary class="mt-lg-n6"/>

                        </v-card>


                    </v-tab-item>
                    </v-tabs-items>
                </v-card>
    </v-app>
</template>

<style scoped>
@import url('../../../assets/css/MonitoringRating/style.css');
</style>

<script>
import LevelTest from '@/components/MonitoringRating/leveltest'
import RegularClass from '@/components/MonitoringRating/regularclass'
import Summary from '@/components/MonitoringRating/summary'
export default {
    name: "rating",
    components:{
        LevelTest,
        RegularClass,
        Summary
    },
    data:()=>{
        return {
            tab: null,
            tab2:null,
            items: [
            'LEVEL TEST', 'REGULAR CLASS', 'SUMMARY'
            ],
            text:'asasasa',
            dates: [new Date().toISOString().substr(0, 10)],
            Regdates: [new Date().toISOString().substr(0, 10)],
            menu: false,
            modal: false,
            menu2: false,
        }
    },
     computed: {
      datess() {
        return this.dates.join(' - ')
      },
      Regdatess() {
        return this.Regdates.join(' - ')
      },
    },
}
</script>